import React from 'react';
import { cn } from '@/lib/utils';

// The standard portal page wrapper (p-4 md:p-8 space-y-6), previously
// copy-pasted per page. Pass `title` to also render the header row.
export default function PageContainer({
  title,
  subtitle,
  actions,
  titleProps,
  subtitleProps,
  className,
  children,
  ...rest
}) {
  return (
    <div className={cn('p-4 md:p-8 space-y-6', className)} {...rest}>
      {title ? (
        <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
          <div className="min-w-0">
            <h1 className="font-serif text-3xl font-bold text-brand-navy" {...titleProps}>
              {title}
            </h1>
            {subtitle ? (
              <p className="text-slate-500 mt-1" {...subtitleProps}>
                {subtitle}
              </p>
            ) : null}
          </div>
          {actions}
        </div>
      ) : null}
      {children}
    </div>
  );
}
